import { UserInfo } from '~/src/store/modules/user/types';
import { OFetchRequestOptions, useOFetch } from '../../requests';
import { CustomFetchContext } from '../../requests/types';
import { ApiResponse } from '../../types';
import { GLOBAL_CONFIG } from '~/configs/environment/environment';
import { GetUserSubjectResponse, SetUserSubjectResponse } from './types';

// 获取用户信息
export const fetchUserInfo = async (
  query = {},
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<UserInfo>> => {
  return await useOFetch<UserInfo>(
    `${GLOBAL_CONFIG.envConfig.eduUrl}/center/user/index/ajax-get-user-info-fast`,
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};

// 获取用户当前分类
export const getUserSubject = async (
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<GetUserSubjectResponse>> => {
  return await useOFetch<GetUserSubjectResponse>(
    '/subject/user-subject',
    {
      method: 'GET',
      ...options,
    },
    fetchContext
  );
};

// 储存用户当前分类 /subject/save
export const setUserSubject = async (
  body?: FormData,
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<SetUserSubjectResponse>> => {
  return await useOFetch(
    '/subject/save',
    {
      method: 'POST',
      body,
      ...options,
    },
    fetchContext
  );
};
